var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutSectionRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2444,
    height: 2109,
    viewBox: "0 0 2444 2109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2077.37 610.877L2290.14 276.901L2276 252.81L2431.76 0.525362",
    stroke: "url(#paint0_linear_3037_783)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2256.82 375.856C2256.74 378.065 2254.89 379.79 2252.68 379.711C2250.47 379.632 2248.74 377.779 2248.82 375.57C2248.9 373.362 2250.76 371.637 2252.97 371.716C2255.17 371.796 2256.9 373.649 2256.82 375.856Z",
    fill: "#326B93"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2241.92 378.836L2109.01 588.081",
    stroke: "url(#paint1_linear_3037_783)",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2241.66 437.122C2237.97 437.212 2234.92 434.464 2234.83 430.982C2234.75 427.499 2237.67 424.605 2241.35 424.515C2245.03 424.425 2248.09 427.173 2248.17 430.656C2248.26 434.138 2245.34 437.032 2241.66 437.122ZM2252.16 432.285L2251.37 432.035C2250.93 431.896 2250.66 431.499 2250.67 431.062C2250.68 430.907 2250.68 430.751 2250.67 430.595C2250.67 430.446 2250.66 430.298 2250.65 430.15L2252.22 429.711C2252.77 429.558 2253.08 429.013 2252.92 428.495L2252.43 426.901C2252.27 426.383 2251.69 426.086 2251.14 426.24L2250.34 426.464C2249.9 426.587 2249.43 426.416 2249.18 426.052L2249.07 425.899C2248.81 425.54 2248.82 425.065 2249.1 424.723L2249.62 424.105C2249.98 423.682 2249.91 423.066 2249.46 422.73L2248.09 421.695C2247.64 421.357 2246.99 421.427 2246.63 421.851L2246.11 422.466C2245.83 422.805 2245.34 422.924 2244.92 422.764C2244.6 422.645 2244.28 422.543 2243.95 422.458C2243.51 422.343 2243.2 421.973 2243.19 421.542L2243.17 420.754C2243.16 420.213 2242.69 419.786 2242.11 419.8L2240.36 419.843C2239.78 419.857 2239.33 420.307 2239.34 420.848L2239.36 421.633C2239.37 422.07 2239.07 422.453 2238.64 422.591L2238.45 422.65C2238.01 422.797 2237.53 422.667 2237.26 422.316L2236.77 421.684C2236.43 421.251 2235.78 421.158 2235.32 421.479L2233.9 422.468C2233.44 422.789 2233.34 423.403 2233.68 423.837L2234.17 424.471C2234.45 424.822 2234.44 425.298 2234.16 425.649L2234.04 425.797C2233.78 426.152 2233.3 426.308 2232.86 426.169L2232.07 425.92C2231.53 425.746 2230.94 426.024 2230.76 426.537L2230.2 428.111C2230.01 428.625 2230.3 429.18 2230.85 429.352L2231.63 429.602C2232.07 429.741 2232.35 430.138 2232.34 430.575C2232.33 430.73 2232.33 430.886 2232.33 431.043C2232.34 431.191 2232.35 431.339 2232.36 431.487L2230.79 431.926C2230.24 432.079 2229.93 432.624 2230.09 433.142L2230.58 434.736C2230.74 435.255 2231.32 435.551 2231.87 435.397L2232.67 435.174C2233.11 435.05 2233.58 435.221 2233.83 435.584L2233.94 435.738C2234.2 436.097 2234.19 436.572 2233.9 436.914L2233.38 437.531C2233.03 437.955 2233.1 438.571 2233.54 438.908L2234.92 439.942C2235.36 440.279 2236.01 440.21 2236.37 439.786L2236.9 439.169C2237.18 438.832 2237.66 438.713 2238.09 438.872C2238.4 438.992 2238.72 439.094 2239.05 439.179C2239.49 439.294 2239.8 439.664 2239.81 440.096L2239.83 440.883C2239.85 441.423 2240.32 441.851 2240.89 441.837L2242.65 441.794C2243.22 441.78 2243.68 441.33 2243.66 440.789L2243.64 440.004C2243.63 439.567 2243.93 439.184 2244.37 439.046L2244.56 438.987C2244.99 438.84 2245.48 438.97 2245.75 439.321L2246.24 439.951C2246.58 440.386 2247.23 440.479 2247.69 440.157L2249.11 439.171C2249.57 438.847 2249.67 438.234 2249.33 437.799L2248.83 437.166C2248.56 436.815 2248.57 436.339 2248.85 435.99L2248.96 435.839C2249.23 435.485 2249.71 435.33 2250.15 435.468L2250.93 435.717C2251.48 435.891 2252.07 435.613 2252.25 435.1L2252.81 433.525C2252.99 433.012 2252.7 432.456 2252.16 432.285Z",
    fill: "#0C3B65"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2190.31 491.188L2137.45 573.48L2138.76 574.286L2191.62 491.994",
    fill: "url(#paint2_linear_3037_783)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.11 528.859C2171.06 531.345 2169.01 533.321 2166.53 533.275C2164.04 533.228 2162.06 531.176 2162.11 528.69C2162.16 526.206 2164.21 524.23 2166.69 524.276C2169.18 524.323 2171.16 526.375 2171.11 528.859Z",
    fill: "#255D86"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_d_3037_783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2078.89 610.188L711.913 608.775L712.799 1873.96L1241.5 1873.96L2078.89 610.188Z",
    fill: "url(#paint3_linear_3037_783)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3037_783",
    x: 691.913,
    y: 598.775,
    width: 1406.98,
    height: 1305.18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3037_783"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3037_783",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3037_783",
    x1: 2265.15,
    y1: 355.974,
    x2: 2440.68,
    y2: 182.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C3B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293637,
    stopColor: "#63515F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3B65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3037_783",
    x1: 2123.22,
    y1: 600.461,
    x2: 2284.15,
    y2: 422.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#142E53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706363,
    stopColor: "#21446E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35719A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3037_783",
    x1: 2141.5,
    y1: 574.391,
    x2: 2191.05,
    y2: 490.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387CA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103B5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3037_783",
    x1: 2367.09,
    y1: 342.73,
    x2: 1642.72,
    y2: 1170.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0978BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutSectionRightIcon);
export default __webpack_public_path__ + "static/media/AboutSectionRightIcon.1191811402623347e2d4137d02e5369e.svg";
export { ForwardRef as ReactComponent };